import { TextInput, PasswordInput, Anchor, Title, Text, Container, Button, Flex, Card, Box } from "@mantine/core";
import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "../../components/Logo";
import useAuthStore from "../../store/useAuthStore";
import { useForm } from "@mantine/form";
import { toast } from "react-hot-toast";
import { APP_NAME, COMPANY } from "../../config";

export default function Login() {
  const navigate = useNavigate();
  const handleAuthInit = useAuthStore((state) => state.handleAuthInit);
  const [loading, setLoading] = useState(false);

  const form = useForm({
    initialValues: {
      identifier: "",
      password: "",
    },
  });
  const handleSubmit = async (data) => {
    try {
      setLoading(true);
      const res = await axios({
        url: "/auth/local",
        method: "POST",
        data,
      });
      handleAuthInit(res.data.jwt);
    } catch (error) {
      console.log(error);
      toast.error("로그인에 실패했습니다");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={(theme) => theme.colorScheme === "light" && { backgroundColor: theme.fn.rgba(theme.colors.brand[0], 0.3) }}
    >
      <Container size="xs" h="100svh" mb={0}>
        <Flex direction="column" justify="center" h="100%">
          <Card withBorder shadow="md" p={30} radius="md">
            <Text color="dimmed" size="sm" mb={5}>
              {APP_NAME}에 오신 것을 환영합니다
            </Text>
            <Title order={2} variant="gradient" gradient={{ from: "brand", to: "cyan" }} weight={900} mb="md">
              로그인
            </Title>

            <form onSubmit={form.onSubmit(handleSubmit)}>
              <TextInput
                label="아이디"
                placeholder="아이디를 입력해주세요"
                required
                {...form.getInputProps("identifier")}
                autoComplete="username"
              />
              <PasswordInput
                label="비밀번호"
                placeholder="비밀번호를 입력해주세요"
                required
                {...form.getInputProps("password")}
                autoComplete="current-password"
              />

              <Button fullWidth mt="xl" size="md" mb="lg" type="submit" loading={loading}>
                로그인
              </Button>
            </form>

            {/* <Flex gap="xs" justify="flex-end">
              <Button variant="subtle" size="xs" onClick={() => navigate("/auth/find-account")}>
                아이디 찾기
              </Button>
              <Button variant="subtle" size="xs" onClick={() => navigate("/auth/find-password")}>
                비밀번호 찾기
              </Button>
            </Flex> */}
          </Card>
        </Flex>

        <Box
          ta="center"
          w="100%"
          style={{ position: "fixed", bottom: 15, left: "50%", transform: "translate(-50%, 0)" }}
        >
          <Text mb={4} fw={700}>
            {COMPANY.NAME}
          </Text>
          <Text mb={4} size="sm">
            사업자등록번호: {COMPANY.BUSINESS_NUMBER} ・ 대표자: {COMPANY.CEO}
          </Text>
          <Text size="sm" mb={4}>
            주소: {COMPANY.ADDRESS}
          </Text>
        </Box>
      </Container>
    </Box>
  );
}
